import React from 'react';
import TelaEntregas from '../components/TelaEntregas';

export default function EntregaServicosDropdown() {
  return <TelaEntregas tipo="servico" />;
}
